import React, { Fragment, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';

import { Button, Grid, Stack, Typography } from '@mui/material';


import { CustomCheckBox, CustomTextArea, CustomTextBox, CustomTextEditor } from 'components/forms';
import { validationRule } from 'utils/global';
import { useToastMessage } from 'hooks';
import SectionLayout from 'layouts/SectionLayout';
import { services } from 'redux/services';
import { Save } from '@mui/icons-material';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { HoverLoader } from 'components';

const BulkNotification: React.FC<any> = () => {
    const { toastMessage } = useToastMessage();
    const [open, setOpen] = useState(false);

    const { handleSubmit, formState: { errors }, watch, control, reset } = useForm({ mode: 'all' });
    const { formatMessage } = useIntl();
    const [loading, setLoading] = useState(false);


    function onSubmit(data: any) {
        setLoading(true);
        services.sendPushNotification({
            title: data.title,
            message: data.message
        })
            .then((res: any) => {
                setOpen(false);
                reset();
                toastMessage(formatMessage({ id: 'send-message' }, { title: formatMessage({ id: 'notification' }) }));
            })
            .catch((err: any) => {
                toastMessage(JSON.stringify(err?.data?.message) || "Something wrong !", 'error');
            }).finally(() => setLoading(false))
    }

    function onSend() {
        setOpen(true)
    }

    return (<SectionLayout title={'Push Notification'}>
            {loading && <HoverLoader />}
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <CustomTextBox
                        label={formatMessage({ id: "title" })}
                        name="title"
                        control={control}
                        error={errors?.title}
                        rules={validationRule.textbox({ required: true })}
                    />
                </Grid>

                <Grid item xs={12}>
                    <CustomTextArea
                        placeholder={formatMessage({ id: "message" })}
                        name="message"
                        control={control}
                        minRows={6}
                        error={errors?.message}
                        rules={validationRule.textbox({ required: true })}
                        required
                    />
                </Grid>
            </Grid>
            <Stack direction="row" alignItems="center" justifyContent="flex-end" my={1}>
                <Button variant="contained" type='submit' onClick={handleSubmit(onSend)} startIcon={<Save />}>
                    Submit
                </Button>
            </Stack>

            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title" bgcolor="darkgrey">
                    <Typography variant="body1" color="textPrimary">{formatMessage({ id: "notification" })}</Typography>
                </DialogTitle>

                <DialogContent>
                    <DialogContentText id="alert-dialog-description" paddingY={2}>
                        <Typography variant="h6" color="textPrimary">{watch('title')}</Typography>
                        <Typography variant="body1" color="textPrimary">{watch('message')}</Typography>
                    </DialogContentText>
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setOpen(false)} color="error" variant="outlined">
                        {formatMessage({ id: "close" })}
                    </Button>
                    <Button onClick={handleSubmit(onSubmit)} color="info" variant="contained">
                        Send Push Notification
                    </Button>
                </DialogActions>
            </Dialog>
        </SectionLayout>
    )
}

export default BulkNotification;